import { css } from '@emotion/core'
import { colors, measures, spacing } from 'styles/variables'
import * as MEDIA from 'styles/media-queries'

const { unit } = measures

export const container = css`
  background-color: ${colors.black100};

  overflow: auto;

  height: inherit;
  width: inherit;
`
// linear-gradient(,)
export const contentContainer = css`
  min-height: calc(100% - ${12.25 * unit}px);
  background-color: ${colors.newColors.dark2};
  width: inherit;
  ${MEDIA.PHONES} {
    padding-top: 0;
    background-color: ${colors.black100};
  }
  ${MEDIA.TABLETS} {
    padding-top: 0;
    background-color: ${colors.black100};
  }
`

export const content = css`
  position: relative;

  ${(MEDIA.NOT_PHONES, MEDIA.NOT_TABLETS)} {
    margin-left: ${spacing(43.75)};
    width: calc(100% - ${spacing(43.75)});
  }
`
